import { queryOptions } from '@tanstack/react-query';

import type { MeResponse, User } from '../generated';
import { createQueryKey } from '../helpers';
import sdk from '../instance';

export type AuthUser = User & {
  permissions: MeResponse['permissions'];
};

export const profileQueryKey = 'auth/profile';

export const mapMeToAuthUser = (me: MeResponse): AuthUser => ({
  ...me.user,
  permissions: me.permissions,
});

export const profileQueryOptions = (enabled: boolean) =>
  queryOptions({
    queryKey: createQueryKey({ key: profileQueryKey }),
    queryFn: async (): Promise<AuthUser> => {
      const me = await sdk.requests.getMe();

      return mapMeToAuthUser(me);
    },
    enabled,
  });
